import React from 'react';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { CostSection } from './components/CostSection';
import { SolutionSection } from './components/SolutionSection';
import { VolumesSection } from './components/VolumesSection';
import { BonusesSection } from './components/BonusesSection';
import { BonusValueSection } from './components/BonusValueSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel();
  return <div className="w-full bg-ivory font-sans text-ink" data-id="element-0" data-mp="23ujha3i1d6za">
      <Hero data-id="element-1" data-mp="3ik7k0rkruvvx" />
      <main data-id="element-2" data-mp="3ikr0e3urxc7u">
        <ProblemSection data-id="element-3" data-mp="3iiwaeb4natww" />
        <CostSection data-id="element-4" data-mp="3ijpcuzwkmx98" />
        <SolutionSection data-id="element-5" data-mp="3ii4ppvcl6gle" />
        <VolumesSection data-id="element-6" data-mp="3ml1234bj9ggw" />
        <BonusesSection data-id="element-7" data-mp="3mk852v2dm5by" />
        <BonusValueSection data-id="element-8" data-mp="3mjg9hk8s47lo" />
        <OfferSection data-id="element-9" data-mp="3rcj5s04xxv5k" />
        <GuaranteeSection data-id="element-10" data-mp="3rbznujfaj6rj" />
        <TestimonialsSection data-id="element-11" data-mp="3rcswjpxt86cb" />
        <FaqSection data-id="element-12" data-mp="3relvsk63foaa" />
        <FinalCtaSection data-id="element-13" data-mp="6hqtghuuhen" />
      </main>
      <Footer data-id="element-14" data-mp="5gez9t0lqvv" />
      <StickyCta data-id="element-15" data-mp="56lhc8rh1lf" />
    </div>;
}